import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface StatItemProps {
  value: string;
  label: string;
  delay: number;
}

const StatItem: React.FC<StatItemProps> = ({ value, label, delay }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.5, delay: delay * 0.1 }}
      className="text-center"
    >
      <p className="font-serif text-4xl md:text-5xl font-bold mb-2">{value}</p>
      <p className="text-gray-600">{label}</p>
    </motion.div>
  );
};

const Stats: React.FC = () => {
  const stats = [
    { value: "₹100Cr+", label: "Assets Managed" },
    { value: "98%", label: "Client Retention" },
    { value: "21%", label: "Average Annual Return" },
    { value: "5,000+", label: "Active Clients" }
  ];

  return (
    <section className="py-16 bg-primary-50">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <StatItem
              key={index}
              value={stat.value}
              label={stat.label}
              delay={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;